import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import { ExecuteOperationOnPipe, ModelWithForm } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import * as Filters from 'support/filters'
import * as UI from 'ui'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import DeleteButton from 'ui/buttons/DeleteButton'
import { Fieldset } from 'layouts/index'
import { MountSmartviewOnPipe, ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

export default function EditTabletSmartview ({ create = false, id = null, department = null }) {
  const footer = (
    <UI.ButtonWrap>
      <DeleteModelOnClick
        resourceName='tablets' pipes={(
          <>
            <ExecuteOperationOnPipe resourceName='tablets' operationName='index' />
            <ResetSmartviewOnPipe />
          </>
            )}
      >
        <DeleteButton big />
      </DeleteModelOnClick>
      <UI.Button type='submit' text={<Translation name='actions.submit' />} />
    </UI.ButtonWrap>
  )

  return (
    <Translator namespace='settings.tablets.smartviews.edit_tablet_smartview'>
      <ModelWithForm resourceName='tablets' id={id}>
        {!create ? <Filters.AutoFetchFilter /> : null}
        <Smartview footer={footer}>
          <UI.CardHeader>
            <UI.SecondaryHeading>
              {(create === true) ? (<Translation name='create_title' />) : (<Translation name='edit_title' />)}
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <Fieldset>
            <Fields.Hidden name='department_id' defaultValue={department} />
            <Fields.Input name='name' label={<Translation name='fields.name.label' />} />
          </Fieldset>
        </Smartview>
        <ExecuteOperationOnPipe resourceName='tablets' operationName='index' />
        <MountSmartviewOnPipe smartview={payload => <EditTabletSmartview id={payload.data.model.id} />} replace={false} />
      </ModelWithForm>
    </Translator>
  )
}
